import { render, staticRenderFns } from "./MenuOptions.vue?vue&type=template&id=0d63d09a&scoped=true"
import script from "./MenuOptions.vue?vue&type=script&lang=js"
export * from "./MenuOptions.vue?vue&type=script&lang=js"
import style0 from "./MenuOptions.vue?vue&type=style&index=0&id=0d63d09a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d63d09a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d63d09a')) {
      api.createRecord('0d63d09a', component.options)
    } else {
      api.reload('0d63d09a', component.options)
    }
    module.hot.accept("./MenuOptions.vue?vue&type=template&id=0d63d09a&scoped=true", function () {
      api.rerender('0d63d09a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/menu/MenuOptions.vue"
export default component.exports